import {
  GET_MERCHANT_ALIAS_DETAILS,
  GET_MERCHANT_OWNER_DETAILS,
  USER_NAME,
  VALIDATE_TOKEN,
  user,
} from 'utils/constants';
import request from 'utils/request';
import _get from 'lodash/get';

export const validateToken = async token => {
  try {
    const { url, method } = VALIDATE_TOKEN;
    const options = {
      method,
      token,
    };
    const response = await request(url, options);

    return response;
  } catch (err) {
    return {};
  }
};

export const fetchUserDetails = async (token, userType, aliasEmail) => {
  const merchantOwner = user.MERCHANT_OWNER;

  try {
    const { url, method } =
      userType === merchantOwner
        ? GET_MERCHANT_OWNER_DETAILS
        : GET_MERCHANT_ALIAS_DETAILS;
    const options = {
      method,
      token,
    };

    const response = await request(url, options);
    let name = _get(response, 'name', '');
    let email = _get(response, 'email', '');

    if (!name) name = USER_NAME;
    if (!email) email = aliasEmail;

    return {
      name,
      email,
    };
  } catch (err) {
    return {
      name: USER_NAME,
      email: 'NA',
    };
  }
};
